import React, { Component } from 'react'


import gif2 from '../../assets/gif/2.gif'


const gifs = [gif2]
const links = [
  { url: 'https://t.me/diffick', label: 'LINK' },

]

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hasError: false,
      selectedGif: null,
      selectedLink: null
    }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo)
  }

  componentDidMount() {
    const selectedGif = gifs[Math.floor(Math.random() * gifs.length)]
    const selectedLink = links[Math.floor(Math.random() * links.length)]
    this.setState({ selectedGif, selectedLink })
  }

  handleClick = () => {
    window.location.reload()
  }

  render() {
    const { hasError, selectedGif, selectedLink } = this.state

    if (hasError) {
      return (
          <div
              style={{
                textAlign: 'center',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
              }}
          >
            <h1>Something went wrong!</h1>
            <p>Click on the gif to reload the page</p>
            <img
                src={selectedGif}
                alt='Snoop Dogg gif'
                onClick={this.handleClick}
                style={{ cursor: 'pointer', maxWidth: '100%', height: 'auto' }}
            />

            <p>
              Also u can write me{' '}
              <a rel='noreferrer noopener' href='https://t.me/diffick'>
                LINK{' '}
              </a>
              and I will help to fix it
            </p>
          </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
